import axios from 'axios';
import { api_url, api_url_login } from '../conf/conf';


export async function getUsers() {
    try {
        // const response = await axios.post('http://147.45.154.215:3000/getUsers');
        const response = await axios.post(api_url + '/getUsers');

        console.log('Response:', response.data);
        return response.data; // предполагаем, что ответ содержит массив пользователей под ключом `users`
    } catch (error) {
        console.error('Error:', error.response ? error.response.data : error.message);
        return [];
    }
}

export async function getMessages(email) {
    try {
        const response = await axios.post(api_url + '/getMessages', { email });
        console.log('Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Ошибка при получении сообщений:', error.response ? error.response.data : error.message);
        return [];
    }
}

export async function updateUser(data) {
    try {
        const response = await axios.post(api_url + '/updateUserStatus', data);
        console.log('Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error:', error.response ? error.response.data : error.message);
        return '';
    }
}


export async function getUserTokensByDate(userId) {
    console.log('getUserTokensByDate userId:', userId);
    try {
        const response = await axios.post(`${api_url}/getUserTokensByDate`, { userId });
        console.log('Response:', response.data);
        return response.data.data;
    } catch (error) {
        console.error('Error:', error.response ? error.response.data : error.message);
        return null;
    }
}

export async function sendMessageToUsers(message, file) {
    const formData = new FormData();
    formData.append('message', message);
    if (file) formData.append('file', file);

    try {
        const response = await axios.post(`${api_url_login}/sendMessages`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        console.log('Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error:', error.response ? error.response.data : error.message);
        throw new Error('Ошибка при отправке сообщения');
    }
}

export async function grantSubscription(email, subscriptionType, durationMonths) {
    try {
        const response = await axios.post(`${api_url}/grantSubscription`, {
            email,
            subscriptionType,
            durationMonths
        });
        console.log('Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error:', error.response ? error.response.data : error.message);
        throw new Error('Ошибка при выдаче подписки');
    }
}
